


import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SEO from './components/SEO';
import HomePage from './pages/HomePage';
import StudyAbroadPage from './pages/StudyAbroadPage';
import WorkAbroadPage from './pages/WorkAbroadPage';
import CanadaPRPage from './pages/CanadaPRPage';
import AustraliaPRPage from './pages/AustraliaPRPage';
import AustraliaCareWorkforcePage from './pages/AustraliaCareWorkforcePage';
import AustraliaCareWorkforceIntakePage from './pages/AustraliaCareWorkforceIntakePage';
import ManageCareWorkforceApplicationsPage from './pages/ManageCareWorkforceApplicationsPage';
import UnsubscribePage from './pages/UnsubscribePage';
import ManageUnsubscribesPage from './pages/ManageUnsubscribesPage';
import CampaignMonitorPage from './pages/CampaignMonitorPage';
import NewZealandPRPage from './pages/NewZealandPRPage';
import PortugalPRPage from './pages/PortugalPRPage';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
// import FormManagement from './pages/FormManagement';
import AboutUs from './pages/AboutUs';
import Pricing from './pages/Pricing';
// import HowItWorks from './pages/HowItWorks';
// import WhyAC from './pages/WhyAC';
import Cookie from './pages/Cookie';
import Terms from './pages/Terms';
import Policy from './pages/Policy';
// import VideoReviews from './pages/VideoReviews';
// import RomanceScam from './pages/RomanceScam';
// import InvoiceScam from './pages/InvoiceScam';
// import CryptoScam from './pages/CryptoScam';
// import SafeAccountScam from './pages/SafeAccountScam';
// import InvestmentScam from './pages/InvestmentScam';
// import JobTaskScam from './pages/JobTaskScam';
// import PurchaseScam from './pages/PurchaseScam';
// import UnauthorisedScam from './pages/UnauthorisedScam';
// import SkilledWorkerEmploymentVisas from './pages/SkilledWorkerEmploymentVisas';
// import StudyPermitsGraduatePathways from './pages/StudyPermitsGraduatePathways';
// import FamilyDependentVisas from './pages/FamilyDependentVisas';
// import PermanentResidenceCitizenship from './pages/PermanentResidenceCitizenship';
// import InvestorEntrepreneurVisas from './pages/InvestorEntrepreneurVisas';
// import VisitorShortStay from './pages/VisitorShortStay';
// import AppealsComplexCases from './pages/AppealsComplexCases';
// import UnitedStates from './pages/UnitedStates';
// import Canada from './pages/Canada';
// import UnitedKingdom from './pages/UnitedKingdom';
// import GermanyEU from './pages/GermanyEU';
// import Australia from './pages/Australia';
// import UAE from './pages/UAE';
import Contact from './pages/Contact';
import InvoicePayments from './pages/InvoicePayments';
import ManageInvoices from './pages/ManageInvoices';
import NotFound from './pages/NotFound';  // Import the NotFound page
import BlogPage from './pages/BlogPage';
import PracticalGuideStudyingAbroad from './pages/blog/PracticalGuideStudyingAbroad';
import WorkingAbroadPreparation from './pages/blog/WorkingAbroadPreparation';
import InformedDecisionsStudyWorkAbroad from './pages/blog/InformedDecisionsStudyWorkAbroad';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <SEO />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/study-abroad" element={<StudyAbroadPage />} />
        <Route path="/work-abroad" element={<WorkAbroadPage />} />
        <Route path="/permanent-residency/canada" element={<CanadaPRPage />} />
        <Route path="/permanent-residency/australia" element={<AustraliaPRPage />} />
        <Route path="/permanent-residency/australia-care-workforce" element={<AustraliaCareWorkforcePage />} />
        <Route path="/forms/australia-care-workforce-intake" element={<AustraliaCareWorkforceIntakePage />} />
        <Route path="/manage/care-workforce-applications" element={<ManageCareWorkforceApplicationsPage />} />
        <Route path="/unsubscribe" element={<UnsubscribePage />} />
        <Route path="/manage/unsubscribes" element={<ManageUnsubscribesPage />} />
        <Route path="/manage/campaign-monitor" element={<CampaignMonitorPage />} />
        <Route path="/permanent-residency/new-zealand" element={<NewZealandPRPage />} />
        <Route path="/permanent-residency/portugal" element={<PortugalPRPage />} />
        <Route path="/pricing" element={<Pricing />} />
        {/* <Route path="/start-claim" element={<StartClaim />} />  */}
        <Route path="/about" element={<AboutUs />} /> 
        {/* <Route path="/how-it-works" element={<HowItWorks />} />  */}
        {/* <Route path="/why-us" element={<WhyAC />} />  */}
        <Route path="/terms-of-service" element={<Terms />} /> 
        <Route path="/privacy-policy" element={<Policy />} /> 
        <Route path="/cookie-policy" element={<Cookie />} /> 
        {/* <Route path="/reviews" element={<VideoReviews />} />  */}
        {/* <Route path="/scams/romance" element={<RomanceScam />} />  */}
        {/* <Route path="/scams/invoice" element={<InvoiceScam />} />  */}
        {/* <Route path="/scams/investment" element={<InvestmentScam />} />  */}
        {/* <Route path="/scams/crypto" element={<CryptoScam />} />  */}
        {/* <Route path="/scams/safe" element={<SafeAccountScam />} />  */}
        {/* <Route path="/scams/purchase" element={<PurchaseScam />} />  */}
        {/* <Route path="/scams/job" element={<JobTaskScam />} />  */}
        {/* <Route path="/scams/unauthorised" element={<UnauthorisedScam />} />  */}
        {/* <Route path="/services/skilled-worker-employment" element={<SkilledWorkerEmploymentVisas />} /> */}
        {/* <Route path="/services/skilled-worker-employment-visas" element={<SkilledWorkerEmploymentVisas />} /> */}
        {/* <Route path="/services/study-permits-graduate-pathways" element={<StudyPermitsGraduatePathways />} /> */}
        {/* <Route path="/services/family-and-dependent-visas" element={<FamilyDependentVisas />} /> */}
        {/* <Route path="/services/permanent-residence-and-citizenship" element={<PermanentResidenceCitizenship />} /> */}
        {/* <Route path="/services/investor-and-entrepreneur-routes" element={<InvestorEntrepreneurVisas />} /> */}
        {/* <Route path="/services/visitor-and-short-stay" element={<VisitorShortStay />} /> */}
        {/* <Route path="/services/appeals-and-complex-cases" element={<AppealsComplexCases />} /> */}  
        {/* <Route path="/countries/united-states" element={<UnitedStates />} /> */}
        {/* <Route path="/countries/canada" element={<Canada />} /> */}
        {/* <Route path="/countries/united-kingdom" element={<UnitedKingdom />} /> */}
        {/* <Route path="/countries/germany-eu" element={<GermanyEU />} /> */}
        {/* <Route path="/countries/australia" element={<Australia />} /> */}
        {/* <Route path="/countries/uae" element={<UAE />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/invoice/payments" element={<InvoicePayments />} />
        <Route path="/invoice/manage" element={<ManageInvoices />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/practical-guide-studying-abroad" element={<PracticalGuideStudyingAbroad />} />
        <Route path="/blog/working-abroad-preparation" element={<WorkingAbroadPreparation />} />
        <Route path="/blog/informed-decisions-study-work-abroad" element={<InformedDecisionsStudyWorkAbroad />} />
        {/* <Route path="/forms/jndfe8939434ndfd" element={<FormManagement />} /> */}

        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
